'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _reduxModulesAuth = require('redux/modules/auth');

var _reactProgress2 = require("react-progress-2");

var _reactProgress22 = _interopRequireDefault(_reactProgress2);

var _reactDocumentTitle = require('react-document-title');

var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);

var _components = {
	_$App: {
		displayName: 'App'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var App = (function (_Component) {
	_inherits(App, _Component);

	function App() {
		_classCallCheck(this, _App);

		_Component.apply(this, arguments);
	}

	App.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (!this.props.user && nextProps.user) {
			if (nextProps.location.query.backlink) {
				this.context.history.pushState(null, nextProps.location.query.backlink);
			} else {
				this.context.history.pushState(null, '/');
			}
		} else if (this.props.user && !nextProps.user) {
			window.location = '/login';
		}
	};

	App.prototype.render = function render() {
		return _react2['default'].createElement(
			_reactDocumentTitle2['default'],
			{ title: 'Alertoid' },
			_react2['default'].createElement(
				'div',
				null,
				_react2['default'].createElement(_reactProgress22['default'].Component, null),
				this.props.children
			)
		);
	};

	_createClass(App, null, [{
		key: 'propTypes',
		value: {
			children: _react.PropTypes.object.isRequired,
			user: _react.PropTypes.object
		},
		enumerable: true
	}, {
		key: 'contextTypes',
		value: {
			store: _react.PropTypes.object.isRequired,
			history: _react2['default'].PropTypes.object,
			location: _react2['default'].PropTypes.object
		},
		enumerable: true
	}]);

	var _App = App;
	App = _wrapComponent('_$App')(App) || App;
	App = _reactRedux.connect(function (state) {
		return { user: state.auth.identity };
	})(App) || App;
	return App;
})(_react.Component);

exports['default'] = App;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 962
 ** module chunks = 2
 **/